import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state:{
        query:{}
    },
    mutations:{
        //es6语法，等同edit:funcion(){...}
        getQuery(state,data){
            state.query = data;
        }
    }
});

export default store;
